function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useEffect, useState } from 'react';
import { FormFieldCollectorContext } from "../form/Form";
import PropTypes from "prop-types";
import { FormContext } from "noood/contexts/contexts";
export var CheckboxCollectionContext = /*#__PURE__*/createContext(null);
export default function CheckboxCollection(props) {
  var _props$value, _form_$formObj2;
  var form_collector = useContext(FormFieldCollectorContext);
  var form_ = useContext(FormContext);
  var _useState = useState((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : []),
    _useState2 = _slicedToArray(_useState, 2),
    checked_items = _useState2[0],
    set_checked_items = _useState2[1];
  var __collect = function __collect(value, checked) {
    var this_items = checked_items;
    if (checked) {
      if (props.unique) {
        if (checked_items.indexOf(value) < 0) {
          this_items.push(value);
        }
      } else {
        this_items.push(value);
      }
    } else {
      var idx_of = this_items.findIndex(function (i) {
        return Number(i) === Number(value);
      });
      if (idx_of > -1) {
        this_items.splice(idx_of, 1);
      }
    }
    form_collector === null || form_collector === void 0 || form_collector(this_items, props.name, []);
    set_checked_items(this_items);
  };
  useEffect(function () {
    var _form_$formObj;
    if (form_ !== null && form_ !== void 0 && (_form_$formObj = form_.formObj) !== null && _form_$formObj !== void 0 && _form_$formObj[props.name]) {
      set_checked_items(form_.formObj[props.name]);
    }
  }, [form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2[props.name]]);
  return /*#__PURE__*/React.createElement(CheckboxCollectionContext.Provider, {
    value: {
      __collect: __collect,
      checked_items: checked_items
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: "".concat(props.gap, "px"),
      flexDirection: "".concat(props.flexDirection),
      flexWrap: "wrap"
    }
  }, props.children));
}
CheckboxCollection.propTypes = {
  name: PropTypes.string.isRequired,
  unique: PropTypes.bool,
  label: PropTypes.string,
  gap: PropTypes.number,
  flexDirection: PropTypes.string
};
CheckboxCollection.defaultProps = {
  gap: 0,
  flexDirection: 'row'
};